module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-main"
  }, [_c('div', {
    staticClass: "footer-slider"
  }, [_c('div', {
    staticClass: "footer-slider__main"
  }, [_c('slider', {
    attrs: {
      "slideList": _vm.slides
    }
  })], 1)])]), _c('div', {
    staticClass: "footer-mini"
  }, [_c('div', {
    staticClass: "footer-mini__column"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "copyright__text"
  }, [_vm._v(_vm._s(_vm.$t('copyright')))])])]), _c('div', {
    staticClass: "footer-mini__column"
  }, [_c('a', {
    staticClass: "footer-email",
    attrs: {
      "href": ("mailto:" + (_vm.$t('contact-email'))),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact-email')))]), _c('ul', {
    staticClass: "footer-social"
  }, _vm._l((_vm.social), function(item) {
    return (_vm.$t(item + '-link').length > 0) ? _c('li', {
      staticClass: "footer-social__item"
    }, [_c('a', {
      staticClass: "footer-social__link",
      attrs: {
        "href": _vm.$t(item + '-link'),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$t('social-' + item)))])]) : _vm._e()
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c7cb43c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/the-footer.vue
// module id = 468
// module chunks = 0